import { styled, TableCell, tableCellClasses } from "@mui/material";


export const StyledTableCellHeadRow = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    width: "3%",
    padding: "1% 0 0 0",
    border: "none"
  },
}));

export const StyledTableCellFooterRow = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    width: "4%",
    padding: "1% 0 0 0",
    border: "none"
  },
}));

export const StyledTableCellRow = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    width: "10%",
    padding: "1% 0 0 0",
    border: "none"
  },
}));

export const StyledTableCellMailRow = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    width: "20%",
    padding: "1% 0 0 0",
    border: "none"
  },
}));

export const StyledTableCellAutocompleteRow = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    width: "17%",
    padding: "1% 0 0 0",
    border: "none"
  },
}));